/**
 * useHapticTap — V1.9.8
 *
 * Micro-hook that fires a light `navigator.vibrate(...)` pulse on any
 * click/tap. Silent on desktop / unsupported browsers. Wire it into an
 * element via the returned onClick wrapper:
 *
 *     const hapticProps = useHapticTap();
 *     <button onClick={hapticProps.wrap(handleSave)} />
 *
 * or, for the whole app, call `enableGlobalHaptics()` once at boot.
 */

const canVibrate = () =>
    typeof navigator !== "undefined" && typeof navigator.vibrate === "function";

// Global mode — fires a 10ms pulse on every button/anchor tap.
let installed = false;
export function enableGlobalHaptics() {
    if (installed || typeof window === "undefined") return;
    installed = true;
    window.addEventListener(
        "pointerdown",
        (e) => {
            if (!canVibrate()) return;
            const t = e.target;
            if (!t || !t.closest) return;
            if (
                t.closest("button:not(:disabled), [role='button']:not(:disabled), a[data-tap-scale]")
            ) {
                try {
                    navigator.vibrate(6);
                } catch {
                    /* ignore */
                }
            }
        },
        { passive: true },
    );
}

// Manual mode.
export function useHapticTap(ms = 10) {
    return {
        wrap: (handler) => (event) => {
            if (canVibrate()) {
                try {
                    navigator.vibrate(ms);
                } catch {
                    /* ignore */
                }
            }
            if (typeof handler === "function") handler(event);
        },
    };
}
